<template>
  <!-- <v-container fluid class="grey lighten-5"> -->
  <div>
    <v-app>
      <router-view />
    </v-app>
    <v-snackbar color="red" v-model="toastError" :timeout="5000">
      <h3>Error: {{ message }}</h3>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="toastError = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar color="green" v-model="toastSuccess" :timeout="5000">
      <h3>{{ messageSuccess }}</h3>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="toastSuccess = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
  <!-- </v-container> -->
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      me: (state) => state?.me?.data,
      message: (state) => state?.error?.message,
      messageSuccess: (state) => state?.success?.message,
    }),
    toastError: {
      get() {
        return this.$store.state.error.isToast
      },
      set(value) {
        this.$store.commit('error/SET_TOAST', value)
      },
    },
    toastSuccess: {
      get() {
        return this.$store.state.success.isToast
      },
      set(value) {
        this.$store.commit('success/SET_TOAST', value)
      },
    },
  },

  mounted() {
    // TODO: Move to call from before router
    // if (!this.me) {
    //   this.$store.dispatch('me/getUserProfile')
    // }
  },
}
</script>

<style lang="scss">
#app {
  // 'Poppins', 'Prompt',
  font-family: 'IBM Plex Sans Thai', Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.v-snack__wrapper.v-sheet.theme--dark.red {
  background: #cc0000;
}

.v-snack__wrapper.v-sheet.theme--dark.green {
  background: green;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.rounded-md {
  border-radius: 4px;
}

.v-data-table-header th {
  white-space: nowrap;
}

tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.04);
}

.v-chip.v-size--default {
  width: 100%;
}

.v-list-item__title {
  text-align: left;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 16px !important;
}
</style>
